import {createContext, ReactNode, useContext} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

export enum SettingsBannersEnum {
  INFO = 'INFO',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  LOADING = 'LOADING',
}

export interface SettingsBannerDefinition {
  type: SettingsBannersEnum;
  message: ReactNode;
  dismissAfter?: number;
}

export interface SettingsBannerContextProps {
  showBanner(options: SettingsBannerDefinition): void;
  updateBannerOnTagsBulk(options: SettingsBannerDefinition): void;
  currentBanner?: SettingsBannerDefinition;
  dismissBanner: Handler;
}

/*
 * Context.
 */

export const SettingsBannerContext = createContext<SettingsBannerContextProps>({
  showBanner: () => {},
  updateBannerOnTagsBulk: () => {},
  currentBanner: undefined,
  dismissBanner: () => {},
});

export function useSettingsBanners() {
  return useContext(SettingsBannerContext);
}

export const SettingsBannerProvider = SettingsBannerContext.Provider;
